import { useTranslation } from 'react-i18next';
import { Info } from 'lucide-react';
import { Small } from './typography';

interface ExperimentalAIDisclaimerProps {
  className?: string;
}

export function ExperimentalAIDisclaimer({
  className = '',
}: ExperimentalAIDisclaimerProps) {
  const { t } = useTranslation();

  return (
    <div
      className={`mb-6 p-3 bg-rose-50 border border-rose-200 rounded-lg flex gap-2 ${className}`}
    >
      <Info className='w-5 h-5 text-rose-600 shrink-0 mt-0.5' />
      <div>
        <Small className='text-rose-800 font-semibold mb-1'>
          {t('experimental.disclaimer.title')}
        </Small>
        <Small
          className='text-rose-700 text-xs'
          dangerouslySetInnerHTML={{
            __html: t('experimental.disclaimer.description'),
          }}
        />
      </div>
    </div>
  );
}
